import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import type { ISODate } from '../../common/utils';
import { ValidationDashboardUrl } from './ValidationDashboardUrl';

const postVisualValidationTimeSeriesComparison = (data: {
  valueDateFrom: ISODate;
  valueDateTo: ISODate;
  dataObjectVersionIds1: number[];
  dataObjectVersionIds2: number[];
  rule1Code: string;
  rule2Code: string;
  outliers: boolean;
  hp: boolean;
}) => {
  let url: string = ValidationDashboardUrl.TIME_SERIES_COMPARISON;
  if (data.hp) {
    url = ValidationDashboardUrl.HODRICK_PRESCOTT_COMPARISON;
  } else if (data.outliers) {
    url = ValidationDashboardUrl.OUTLIERS_COMPARISON;
  }
  return apiClient
    .post<{
      externalCode: string;
    }>(url, data)
    .then((response) => response.data);
};

export const useGenerateVisualValidationTimeSeriesComparisonMutation =
  createApiMutationHook(
    ['visualValidationTimeSeriesComparison'],
    postVisualValidationTimeSeriesComparison,
  );
